import { toast } from 'sonner';

/**
 * Finish a successful login: success toast + full reload of `/` so the
 * freshly-set auth cookie (and any just-picked market) applies to the boot
 * request and AccessProvider re-resolves `/users/me`. Booting on `/` keeps
 * AccessProvider's transient-401 retry in charge (`redirectToLoginOn401`
 * stays put only there); the router catch-all then forwards to the landing
 * page (`LandingRedirect`).
 */
export const enterApp = (): void => {
  toast.success('Logged In successfully');
  window.location.href = '/';
};
